import { NgTemplateOutlet } from '@angular/common';
import { Component, inject, OnInit, signal } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';

import { BaseComponent } from 'src/app/components/_base/base.component';
import { LayoutService } from 'src/app/services/layout/layout.service';
import { Banner } from 'src/app/types/general';

@Component({
  templateUrl: './banner.component.html',
  standalone: true,
  selector: 'app-banner',
  imports: [NgTemplateOutlet, MatButtonModule, MatIconModule],
  styles: `
    :host {
      display: block;
      position: sticky;
      top: 0;
      z-index: 30;
    }

    #banner-close-btn {
      --mdc-icon-button-icon-color: rgb(var(--color-primary));
      --mdc-icon-button-state-layer-size: 20px;
      --mdc-icon-button-icon-size: 14px;

      line-height: 1;

      mat-icon {
        width: var(--mdc-icon-button-icon-size);
        height: var(--mdc-icon-button-icon-size);
        font-size: var(--mdc-icon-button-icon-size);
        position: relative;
      }
    }
  `,
})
export class BannerComponent extends BaseComponent implements OnInit {
  readonly banners = signal<Banner[]>([]);

  private readonly layoutService = inject(LayoutService);

  ngOnInit(): void {
    this.sub$ = this.layoutService.banners$.subscribe((banners) => this.banners.set(banners));
  }

  onCloseBanner(index: number) {
    return this.layoutService.closeBanner(index);
  }
}
